export const BASE_URL = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? process.env.REACT_APP_API_GATEWAY_URL
  : process.env.REACT_APP_GRAPHQL_API_URL;

export const BASE_URL_ANONYMOUS = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? `${process.env.REACT_APP_API_GATEWAY_URL}/anonymous/graphql`
  : process.env.REACT_APP_GRAPHQL_ANONYMOUS_API_URL;

export const BASE_REST_URL = process.env.REACT_APP_IS_API_GATEWAY_ENABLED === 'true'
  ? process.env.REACT_APP_API_GATEWAY_URL
  : process.env.REACT_APP_REST_API_URL;
